var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{style:({
      marginBottom: '16px',
      fontWeight: 'bold',
    })},[_vm._v(" Price Range ")]),_c('div',{on:{"click":_vm.handleClick}},[_c('Slider',{ref:"slider",attrs:{"name":"slider","lazy":"","tooltip-formatter":_vm.formatTooltip,"min":0,"max":_vm.sliderMax,"dotOptions":_vm.dotOptions},on:{"drag-end":_vm.handleDrag,"change":_vm.handleChange},model:{value:(_vm.sliderRange),callback:function ($$v) {_vm.sliderRange=$$v},expression:"sliderRange"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }